export default {
  tractTypes: [],
  tractTypeLoadingStatus: 'not loading'
}
